import React, { useState, useRef, useEffect } from 'react';
import { usePdf } from '@mikecousins/react-pdf';
import { styled, fluidRange } from '~/styles';
import Button from '~/components/common/Button';
import browserChecker from '~/utils/browserChecker';
import ReactGA from 'react-ga';
import stripHTML from '~/utils/stripHTML';

const RenderPDFCont = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  canvas {
    border: 1px solid black;
    width: 100% !important;
    height: 100% !important;
  }
  nav {
    width: 100%;
    .pager {
      .previous {
        position: absolute;
        top: 0;
        left: 0;
        @media (max-width: 767px) {
          left: -15px;
        }
      }
      .next {
        position: absolute;
        top: 0;
        right: 0;
        @media (max-width: 767px) {
          right: -15px;
        }
      }
      button {
        height: 90vh;
        display: flex;
        align-items: center;
        >span {
          border: 0;
          min-width: auto;
          ${fluidRange('width', '20px', '67px')};
          >span {
            margin: 0;
          }
        }
      }
    }
    
  }
`

function RenderPDF(props) {
  const [page, setPage] = useState(1);
  const canvasRef = useRef(null);  

  const { pdfDocument, pdfPage } = usePdf({
    file: props.file,
    page,
    canvasRef,
    scale: browserChecker.is_iOS() ? 1 : 1.5
  });

  useEffect(() => {
    document.getElementById('modal-scroll-element')?.scrollTo(0, 0);
  }, [page]);

  const changePage = (pageNumber) => {
    setPage(pageNumber);

    ReactGA.event({
      category: 'PDF',
      action: 'change page',
      value: pageNumber,
      label: stripHTML(props.config.title)
    })
  }

  return (
    <RenderPDFCont>
      {!pdfDocument && <span>Loading...</span>}
      {
        // !!(pdfDocument && pdfDocument.numPages > 1) && (
        !!(pdfDocument && pdfDocument.numPages) && (
          <nav>
            <ul className='pager'>
              <li className='previous'>
                <Button disabled={page === 1} onClick={() => changePage(page - 1)}
                  icon='arrow_left' iconPos='right'
                />
              </li>
              <li className='next'>
                <Button
                  disabled={page === pdfDocument.numPages}
                  onClick={() => changePage(page + 1)}
                  icon='arrow_right' iconPos='right'
                />
              </li>
            </ul>
          </nav>
        )
      }
      <canvas ref={canvasRef} />
    </RenderPDFCont>
  );
}

export default RenderPDF;



// WEBPACK FOOTER //
// ./src/components/parts/RenderPDF.tsx